import Politics from './Politics'

export default Politics
